module.exports = __webpack_public_path__ + "media/components/footer/static/tagline-e6bdc2b4c9ba50c346b93138987db445.png";